// QA doc: features/website/cart.md R-C35
import { NgModule } from '@angular/core';
import { ConfirmModule } from '@shared/modules/confirm/confirm.module';
import { DynamicModalModule } from '@shared/modules/dynamic-modal/dynamic-modal.module';
import { StaleBundleService } from './stale-bundle.service';

@NgModule({
  imports: [DynamicModalModule, ConfirmModule],
  providers: [StaleBundleService]
})
export class StaleBundleModule {}
